import lmsAPI from "./lmsAPI";

class LocationsService {
  async index() {
    const res = await lmsAPI.get(`/locations/`);
    return res.data;
  }

  async get(id) {
    const res = await lmsAPI.get(`/locations/${id}`);
    return res.data;
  }

  async update(id, locationParams) {
    const res = await lmsAPI.put(`/locations/${id}`, {
      location: locationParams,
    });
    return res.data;
  }

  async create(locationParams) {
    const res = await lmsAPI.post(`/locations/`, { location: locationParams });
    return res.data;
  }

  async delete(id) {
    const res = await lmsAPI.delete(`/locations/${id}`);
    return res.data;
  }
}

export default new LocationsService();
